import styled from 'styled-components';
import React from 'react';
import {Icon} from '../../../ui-toolkit/elements/Icon/Icon';

const AlertWrapper = styled.div`
    padding: var(--space-sm) var(--space);
    border: 1px solid var(--danger);
    color: var(--danger);
    display: inline-flex;
    align-items: center;
    margin-bottom: var(--space-lg);
    ${Icon.Wrapper} {
        margin-right: var(--space-xsm);
    }
`;

const AlertContent = styled.div`
    > p:last-of-type {
        margin-bottom: 0;
    }
`;

const Alert = ({children}) => (
    <AlertWrapper>
        <Icon type="md" name="Warning" />
        <AlertContent>{children}</AlertContent>
    </AlertWrapper>
);

export default Alert;
export {AlertWrapper};
